// stores/themeStore.ts
import { defineStore } from 'pinia'
import { ref, computed, watch } from 'vue'

export const useThemeStore = defineStore('theme', () => {
  // localStorage에서 저장된 테마를 불러오거나 기본값 'light' 사용
  const savedTheme = localStorage.getItem('theme') as 'light' | 'dark' | null
  const theme = ref<'light' | 'dark'>(savedTheme || 'light')

  const isDark = computed(() => theme.value === 'dark')

  function toggleTheme() {
    theme.value = isDark.value ? 'light' : 'dark'
    console.log('toggleTheme ', theme.value)
  }

  // 💡 theme이 변경될 때마다 localStorage에 저장하고 <html data-bs-theme="..."> 반영
  watch(theme, (newTheme) => {
    localStorage.setItem('theme', newTheme)
    document.documentElement.setAttribute('data-bs-theme', newTheme)
  }, { immediate: true })

  return { theme, isDark, toggleTheme }
})
